import Image from '@/components/Image';
import { PageHeroProps } from '@/components/_rebrand/heroes/PageHero/PageHero.props';
import SerifAndSansSerifHeadline from '../../product/_organisms/SerifAndSansSerifHeadline';
import { AssetImage, Bullet, FlexPageHeroData } from './FlexPageHero.types';

export const createFeaturedImage = (
  heroImage: AssetImage[]
): PageHeroProps['featuredImage'] => {
  const image = heroImage[0];

  return {
    desktop: {
      url: image?.url ?? 'https://front.com/webassets/rebrand/ticketing-hero.png',
      width: image?.width ?? 505,
      height: image?.height ?? 612,
      alt: image?.alt ?? 'Hero image',
    },
  };
};

export const mapBulletsToPageHeroBullets = (
  bullets: Bullet[]
): PageHeroProps['bullets'] => {
  return bullets?.length ? bullets.map((bullet) => ({
    label: bullet.bulletText,
  })) : [];
};

export const mapLogosToPageHeroLogos = (
  logos: AssetImage[]
): PageHeroProps['logos'] => {
  return logos.map((logo) => (
    <Image
      key={logo.url}
      src={logo.url}
      width={logo.width}
      height={logo.height}
      alt={logo.title}
      style={{ maxWidth: '120px' }}
    />
  ));
};



export const mapEntryToPageHeroProps = (
  entry: FlexPageHeroData,
): Omit<PageHeroProps, 'decorationImageUrl' | 'description'> => {
  const title = (
    <SerifAndSansSerifHeadline
      primarySansSerif={entry.headerSansSerif}
      secondarySerif={entry.headerSerif}
    />
  );

  return {
    title,
    eyebrow: entry.eyebrowText,
    featuredImage: createFeaturedImage(entry.heroImage),
    backgroundColor: entry.heroBackgroundColor || 'violet',
    textStyle: entry.heroTextStyle || 'bullets',
    bullets: mapBulletsToPageHeroBullets(entry.heroBullets),
    paragraph: entry.heroParagraph,
    logos: mapLogosToPageHeroLogos(entry.logos),
    links: [
      {
        type: 'primary',
        title: 'Request a demo',
        href: '',
        action: 'demo',
      },
      {
        type: 'secondary',
        title: 'Try for free',
        href: '',
        action: 'trial',
      },
    ],
    styleOverrides: {
      bottomMarginSpacing: 'none',
      topMarginSpacing: 'none',
    },
  };
};
